import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
    @Input() header: string = 'Modal Header';

    @Output() onSave = new EventEmitter<void>();
    @Output() onCancel = new EventEmitter<void>();

    triggerSave(): void {
        this.onSave.emit();
    }

    triggerCancel(): void {
        this.onCancel.emit();
    }
}
